webpackJsonp([114276838955818,60335399758886],{

/***/ 142:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"hideGuides":true,"email":"mail@andrewgriffithsonline.com","googleSiteVerification":"tFT9lOPF-n9pk5w2SAabmCdG2XKYBlmChnofZqGi3bs","metaTags":[{"page":"home","title":"Andrew Griffiths | Software Developer","description":"Independent consultant helping companies build and scale using serverless technology.","keywords":"serverless consultant, serverless expert, aws lambda consultant"},{"page":"about","title":"About","description":"Independent consultant helping companies build and scale using serverless technology.","keywords":"serverless consultant, serverless expert, aws lambda consultant"},{"page":"training","title":"Serverless Training Workshops","description":"Expert in person training workshops to help your organisation master serverless technology.","keywords":"serverless training, serverless workshops, aws serverless training, aws lambda training"}],"siteUrl":"https://andrewgriffithsonline.com","social":{"twitter":"https://twitter.com/agriffonline","linkedin":"http://uk.linkedin.com/in/andrewgriffithsonline","medium":"https://medium.com/@andrewgriffiths","github":"https://github.com/techjacker"},"title":"Andrew Griffiths"}}},"layoutContext":{}}

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(281);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(142);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

	"use strict";
	
	/* eslint-disable */
	module.exports = {
		hideGuides: true,
		displayBlogPreviewImages: false,
		googleSiteVerification: "tFT9lOPF-n9pk5w2SAabmCdG2XKYBlmChnofZqGi3bs",
		email: "mail@andrewgriffithsonline.com",
		siteUrl: "https://andrewgriffithsonline.com",
		social: {
			twitter: "https://twitter.com/agriffonline",
			github: "https://github.com/techjacker",
			medium: "https://medium.com/@andrewgriffiths",
			linkedin: "http://uk.linkedin.com/in/andrewgriffithsonline"
		},
		title: "Andrew Griffiths",
		description: "Independent technology consultant helping companies build and scale using serverless technology.",
		about: ["I am an independent consultant expert in AWS, Google Cloud & Azure serverless cloud technology.", "I specialise in helping companies build faster, scale and reduce infrastructure costs.",
		// "I specialise in serverless technology.",
	
		"I have 10+ years full stack JavaScript, Python and Golang experience building and deploying web and mobile applications."
		// "I help companies migrate to and build highly scalable infrastructure .",
		// "I specialise in developing applications using serverless technology. I help companies build new products quickly and provide consultancy on how to optimise their current infrastructure."
		// "I specialise in developing applications using serverless technology. I help companies build new products quickly and provide consultancy on how to optimise their current infrastructure."
	
		// "I build applications that scale to millions of users. I am able to do this by selecting the best tools from my 10+ years' experience of full stack web development.",
		// "I am ",
		// "Andrew Griffiths specialises in developing rapid prototypes for startups and companies launching new products.",
		// "Drop me a line to discuss your project."
		// "Expert at building and deploying applications in Golang, Python and JavaScript using serverless platforms.",
		// "Currently building the next generation of blockchain applications on bitcoin's lightning network.",
		// "Available to hire for consultancy and development."
		],
		metaTags: [{
			page: "home",
			title: "Andrew Griffiths | Software Developer",
			description: "Independent consultant helping companies build and scale using serverless technology.",
			keywords: "serverless consultant, serverless expert, aws lambda consultant"
		}, {
			page: "about",
			title: "About",
			description: "Independent consultant helping companies build and scale using serverless technology.",
			keywords: "serverless consultant, serverless expert, aws lambda consultant"
		}, {
			page: "training",
			title: "Serverless Training Workshops",
			description: "Expert in person training workshops to help your organisation master serverless technology.",
			keywords: "serverless training, serverless workshops, aws serverless training, aws lambda training"
		}]
	};

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var config = __webpack_require__(272);
	
	module.exports = {
		plugins: [{
			resolve: "gatsby-plugin-mailchimp",
			options: {
				endpoint: "https://andrewgriffithsonline.us18.list-manage.com/subscribe/post?u=6c0f7f27a528176b3ca44a358&amp;id=bc49592157"
			}
		}, {
			resolve: "gatsby-plugin-favicon",
			options: {
				logo: "./src/images/logo/Light/icon.png",
				injectHTML: true,
				icons: {
					android: true,
					appleIcon: true,
					appleStartup: true,
					coast: false,
					favicons: true,
					firefox: true,
					twitter: true,
					yandex: true,
					windows: true
				}
			}
		}, "gatsby-plugin-remove-trailing-slashes", {
			resolve: "gatsby-plugin-typography",
			options: { pathToConfigModule: "src/utils/typography.js" }
		}, "gatsby-plugin-catch-links", "gatsby-plugin-react-helmet", {
			options: { siteUrl: "https://andrewgriffithsonline.com" },
			resolve: "gatsby-plugin-canonical-urls"
		}, {
			options: { trackingId: "UA-116178207-1" },
			resolve: "gatsby-plugin-google-analytics"
		}, {
			options: {
				name: "markdown",
				path: __dirname + "/markdown"
			},
			resolve: "gatsby-source-filesystem"
		}, {
			options: {
				name: "images",
				path: __dirname + "/src/images"
			},
			resolve: "gatsby-source-filesystem"
		}, "gatsby-transformer-sharp", "gatsby-plugin-sharp", {
			resolve: "gatsby-transformer-remark",
			options: {
				plugins: ["gatsby-remark-smartypants", "gatsby-remark-prismjs", "gatsby-remark-copy-linked-files", "gatsby-plugin-sharp", {
					// https://www.gatsbyjs.org/packages/gatsby-remark-images/
					resolve: "gatsby-remark-images",
					options: {
						/*
	      * Remove the default behavior of adding a link to each
	      * image.
	      */
						linkImagesToOriginal: false,
	
						/*
	      * It's important to specify the maxWidth (in pixels) of
	      * the content container as this plugin uses this as the
	      * base for generating different widths of each image.
	      */
						maxWidth: 1600,
	
						/*
	      * Analyze images' pixel density to make decisions about
	      * target image size. This is what GitHub is doing when
	      * embedding images in tickets. This is a useful setting
	      * for documentation pages with a lot of screenshots.
	      * It can have unintended side effects on high pixel
	      * density artworks.
	      *
	      * Example: A screenshot made on a retina screen with a
	      * resolution of 144 (e.g. Macbook) and a width of 100px,
	      * will be rendered at 50px.
	      *
	      * Defaults to false.
	      */
						sizeByPixelDensity: false
					}
				}]
			}
		}, {
			options: {
				query: "\n\t\t\t\t\t{\n\t\t\t\t\t\tsite {\n\t\t\t\t\t\t\tsiteMetadata {\n\t\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\t\tdescription\n\t\t\t\t\t\t\t\tsiteUrl\n\t\t\t\t\t\t\t\tsite_url: siteUrl\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t",
				feeds: [{
					serialize: function serialize(_ref) {
						var _ref$query = _ref.query,
						    site = _ref$query.site,
						    allMarkdownRemark = _ref$query.allMarkdownRemark;
	
						return allMarkdownRemark.edges.map(function (edge) {
							return _extends({}, edge.node.frontmatter, {
								categories: edge.node.frontmatter.tags,
								date: edge.node.frontmatter.date,
								title: edge.node.frontmatter.title,
								description: edge.node.excerpt,
								guid: site.siteMetadata.siteUrl + edge.node.fields.slug,
								url: site.siteMetadata.siteUrl + edge.node.fields.slug,
								// eslint-disable-next-line camelcase
								custom_elements: [{ "content:encoded": edge.node.html }]
							});
						});
					},
					query: "\n\t\t\t\t\t\t{\n\t\t\t\t\t\t\tallMarkdownRemark(\n\t\t\t\t\t\t\t\tlimit: 1000,\n\t\t\t\t\t\t\t\tsort: { order: DESC, fields: [frontmatter___date] },\n\t\t\t\t\t\t\t\tfilter: { fields: { slug: { regex: \"/^/blog/.+$/\" } } }\n\t\t\t\t\t\t\t) {\n\t\t\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\t\t\texcerpt\n\t\t\t\t\t\t\t\t\t\thtml\n\t\t\t\t\t\t\t\t\t\tfields { slug }\n\t\t\t\t\t\t\t\t\t\tfrontmatter {\n\t\t\t\t\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\t\t\t\t\tdate\n\t\t\t\t\t\t\t\t\t\t\ttags\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t",
					output: "/rss.xml"
				}]
			},
			resolve: "gatsby-plugin-feed"
		}],
		siteMetadata: config
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(371);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_DIR":"/Users/andy/www/andrewgriffithsonline.com/public"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)))

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(604);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(36);
	var isArguments = __webpack_require__(35);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 379:
/***/ (function(module, exports) {

	"use strict";
	
	var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
	// Thanks to:
	// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
	// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
	// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
	exports.validate = function(email)
	{
		if (!email)
			return false;
			
		if(email.length>254)
			return false;
	
		var valid = tester.test(email);
		if(!valid)
			return false;
	
		// Further checking of some things regex can't handle
		var parts = email.split("@");
		if(parts[0].length>64)
			return false;
	
		var domainParts = parts[1].split(".");
		if(domainParts.some(function(part) { return part.length>63; }))
			return false;
	
		return true;
	}

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gatsbyConfig = __webpack_require__(273);
	
	var _gatsbyConfig2 = _interopRequireDefault(_gatsbyConfig);
	
	var _jsonp = __webpack_require__(490);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _emailValidator = __webpack_require__(379);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * make a jsonp request to user's mailchimp list
	 * url is a concatenated string of user's gatsby-config.js
	 * options, along with any MC list fields as query params
	 */
	
	var subscribeEmailToMailchimp = function subscribeEmailToMailchimp(url) {
	  return new Promise(function (resolve, reject) {
	    // `param` object avoids CORS issues
	    return (0, _jsonp2.default)(url, { param: 'c' }, function (err, data) {
	      if (err) reject(err);
	      if (data) resolve(data);
	    });
	  });
	};
	
	/*
	 * parse the plugin options to use in our jsonp request
	 */
	
	var getPluginOptions = function getPluginOptions() {
	  // find gatsby-mailchimp plugin options (MC list settings)
	  var options = _gatsbyConfig2.default.plugins.find(function (plugin) {
	    return plugin.resolve === 'gatsby-plugin-mailchimp';
	  }).options;
	
	  var isString = typeof options.endpoint === 'string';
	  if (!isString) {
	    throw 'Mailchimp endpoint required and must be of type string. See repo README for more info.';
	  }
	  return options;
	};
	
	/*
	 * build a query string of MC list fields
	 * ex: '&KEY1=value1&KEY2=value2'
	 * (toUpperCase because that's what MC requires)
	 */
	
	var convertListFields = function convertListFields(fields) {
	  var queryParams = '';
	  for (var field in fields) {
	    queryParams = queryParams.concat('&' + field.toUpperCase() + '=' + fields[field]);
	  }
	  return queryParams;
	};
	
	/*
	 * accept email (String) and additional, optional
	 * Mailchimp list fields (Object)
	 * then make jsonp req with data
	 */
	
	var addToMailchimp = function addToMailchimp(email, fields) {
	  var isEmailValid = (0, _emailValidator.validate)(email);
	  var emailEncoded = encodeURIComponent(email);
	  if (!isEmailValid) {
	    throw 'gatsy-plugin-mailchimp: email must be of type string and a valid email address. See README for more information.';
	  }
	
	  // generate Mailchimp endpoint for jsonp request
	  // note, we change `/post` to `/post-json`
	  // otherwise, Mailchomp returns an error
	
	  var _getPluginOptions = getPluginOptions(),
	      endpoint = _getPluginOptions.endpoint;
	
	  endpoint = endpoint.replace(/\/post/g, '/post-json');
	
	  var queryParams = '&EMAIL=' + emailEncoded + convertListFields(fields);
	  var url = '' + endpoint + queryParams;
	  return subscribeEmailToMailchimp(url);
	};
	
	exports.default = addToMailchimp;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(370)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ }),

/***/ 604:
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var BurgerIcon = (function (_Component) {
	  _inherits(BurgerIcon, _Component);
	
	  function BurgerIcon(props) {
	    _classCallCheck(this, BurgerIcon);
	
	    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      hover: false
	    };
	  }
	
	  _createClass(BurgerIcon, [{
	    key: 'getLineStyle',
	    value: function getLineStyle(index) {
	      return {
	        position: 'absolute',
	        height: '20%',
	        left: 0,
	        right: 0,
	        top: 20 * (index * 2) + '%',
	        opacity: this.state.hover ? 0.6 : 1
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon = undefined;
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        opacity: 0,
	        fontSize: 8,
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-icon',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmIcon)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          null,
	          [0, 1, 2].map(function (bar) {
	            return _react2['default'].createElement('span', {
	              key: bar,
	              className: ('bm-burger-bars ' + _this.props.barClassName).trim(),
	              style: _extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-burger-button ' + this.props.className).trim(),
	          style: _extends({ zIndex: 1000 }, this.props.styles.bmBurgerButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          {
	            onClick: this.props.onClick,
	            onMouseOver: function () {
	              return _this.setState({ hover: true });
	            },
	            onMouseOut: function () {
	              return _this.setState({ hover: false });
	            },
	            style: buttonStyle
	          },
	          'Open Menu'
	        )
	      );
	    }
	  }]);
	
	  return BurgerIcon;
	})(_react.Component);
	
	exports['default'] = BurgerIcon;
	
	BurgerIcon.propTypes = {
	  barClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	BurgerIcon.defaultProps = {
	  barClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var CrossIcon = (function (_Component) {
	  _inherits(CrossIcon, _Component);
	
	  function CrossIcon() {
	    _classCallCheck(this, CrossIcon);
	
	    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CrossIcon, [{
	    key: 'getCrossStyle',
	    value: function getCrossStyle(type) {
	      return {
	        position: 'absolute',
	        width: 3,
	        height: 14,
	        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon;
	      var buttonWrapperStyle = {
	        position: 'absolute',
	        width: 24,
	        height: 24,
	        right: 8,
	        top: 8
	      };
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        textIndent: -9999,
	        background: 'transparent',
	        outline: 'none',
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-cross',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmCross)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          { style: { position: 'absolute', top: '6px', right: '14px' } },
	          ['before', 'after'].map(function (type, i) {
	            return _react2['default'].createElement('span', {
	              key: i,
	              className: ('bm-cross ' + _this.props.crossClassName).trim(),
	              style: _extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-cross-button ' + this.props.className).trim(),
	          style: _extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          { onClick: this.props.onClick, style: buttonStyle },
	          'Close Menu'
	        )
	      );
	    }
	  }]);
	
	  return CrossIcon;
	})(_react.Component);
	
	exports['default'] = CrossIcon;
	
	CrossIcon.propTypes = {
	  crossClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	CrossIcon.defaultProps = {
	  crossClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var styles = {
	  overlay: function overlay(isOpen) {
	    return {
	      position: 'fixed',
	      zIndex: 1000,
	      width: '100%',
	      height: '100%',
	      background: 'rgba(0, 0, 0, 0.3)',
	      opacity: isOpen ? 1 : 0,
	      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      zIndex: 1100,
	      width: width,
	      height: '100%',
	      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  menu: function menu() {
	    return {
	      height: '100%',
	      boxSizing: 'border-box',
	      overflow: 'auto'
	    };
	  },
	
	  itemList: function itemList() {
	    return {
	      height: '100%'
	    };
	  },
	
	  item: function item() {
	    return {
	      display: 'block',
	      outline: 'none'
	    };
	  },
	
	  burgerIcon: function burgerIcon(isOpen, width, right) {
	    return {};
	  }
	};
	
	exports['default'] = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(156);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _baseStyles = __webpack_require__(610);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _BurgerIcon = __webpack_require__(608);
	
	var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);
	
	var _CrossIcon = __webpack_require__(609);
	
	var _CrossIcon2 = _interopRequireDefault(_CrossIcon);
	
	exports['default'] = function (styles) {
	  var Menu = (function (_Component) {
	    _inherits(Menu, _Component);
	
	    function Menu(props) {
	      _classCallCheck(this, Menu);
	
	      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
	      this.state = {
	        isOpen: false
	      };
	    }
	
	    _createClass(Menu, [{
	      key: 'toggleMenu',
	      value: function toggleMenu() {
	        var _this = this;
	
	        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	        var isOpen = options.isOpen;
	        var noStateChange = options.noStateChange;
	
	        var newState = {
	          isOpen: typeof isOpen !== 'undefined' ? isOpen : !this.state.isOpen
	        };
	
	        this.applyWrapperStyles();
	
	        this.setState(newState, function () {
	          !noStateChange && _this.props.onStateChange(newState);
	
	          // Timeout ensures wrappers are cleared after animation finishes.
	          _this.timeoutId && clearTimeout(_this.timeoutId);
	          _this.timeoutId = setTimeout(function () {
	            _this.timeoutId = null;
	            if (!newState.isOpen) {
	              _this.applyWrapperStyles(false);
	            }
	          }, 500);
	        });
	      }
	
	      // Applies component-specific styles to external wrapper elements.
	    }, {
	      key: 'applyWrapperStyles',
	      value: function applyWrapperStyles() {
	        var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	        if (this.props.bodyClassName) {
	          var body = document.querySelector('body');
	          body.classList[set ? 'add' : 'remove'](this.props.bodyClassName);
	        }
	
	        if (styles.pageWrap && this.props.pageWrapId) {
	          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, set);
	        }
	
	        if (styles.outerContainer && this.props.outerContainerId) {
	          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, set);
	        }
	      }
	
	      // Sets or unsets styles on DOM elements outside the menu component.
	      // This is necessary for correct page interaction with some of the menus.
	      // Throws and returns if the required external elements don't exist,
	      // which means any external page animations won't be applied.
	    }, {
	      key: 'handleExternalWrapper',
	      value: function handleExternalWrapper(id, wrapperStyles, set) {
	        var html = document.querySelector('html');
	        var body = document.querySelector('body');
	        var wrapper = document.getElementById(id);
	
	        if (!wrapper) {
	          console.error("Element with ID '" + id + "' not found");
	          return;
	        }
	
	        var builtStyles = this.getStyle(wrapperStyles);
	
	        for (var prop in builtStyles) {
	          if (builtStyles.hasOwnProperty(prop)) {
	            wrapper.style[prop] = set ? builtStyles[prop] : '';
	          }
	        }
	
	        // Prevent any horizontal scroll.
	        [html, body].forEach(function (element) {
	          element.style['overflow-x'] = set ? 'hidden' : '';
	        });
	      }
	
	      // Builds styles incrementally for a given element.
	    }, {
	      key: 'getStyles',
	      value: function getStyles(el, index, inline) {
	        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());
	
	        // Set base styles.
	        var output = _baseStyles2['default'][el] ? this.getStyle(_baseStyles2['default'][el]) : {};
	
	        // Add animation-specific styles.
	        if (styles[el]) {
	          output = _extends({}, output, this.getStyle(styles[el], index + 1));
	        }
	
	        // Add custom styles.
	        if (this.props.styles[propName]) {
	          output = _extends({}, output, this.props.styles[propName]);
	        }
	
	        // Add element inline styles.
	        if (inline) {
	          output = _extends({}, output, inline);
	        }
	
	        return output;
	      }
	    }, {
	      key: 'getStyle',
	      value: function getStyle(style, index) {
	        var width = this.props.width;
	        if (typeof width !== 'string') width = width + 'px';
	
	        return style(this.state.isOpen, width, this.props.right, index);
	      }
	    }, {
	      key: 'listenForClose',
	      value: function listenForClose(e) {
	        e = e || window.event;
	
	        if (this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'shouldDisableOverlayClick',
	      value: function shouldDisableOverlayClick() {
	        if (typeof this.props.disableOverlayClick === 'function') {
	          return this.props.disableOverlayClick();
	        } else {
	          return this.props.disableOverlayClick;
	        }
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (!styles) {
	          throw new Error('No styles supplied');
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.onkeydown = this.listenForClose.bind(this);
	
	        // Allow initial open state to be set by props.
	        if (this.props.isOpen) {
	          this.toggleMenu({ isOpen: true, noStateChange: true });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.onkeydown = null;
	
	        this.applyWrapperStyles(false);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        var _this2 = this;
	
	        if (styles.svg) {
	          (function () {
	            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
	            var path = styles.svg.lib(morphShape).select('path');
	
	            if (_this2.state.isOpen) {
	              // Animate SVG path.
	              styles.svg.animate(path);
	            } else {
	              // Reset path (timeout ensures animation happens off screen).
	              setTimeout(function () {
	                path.attr('d', styles.svg.pathInitial);
	              }, 300);
	            }
	          })();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        return _react2['default'].createElement(
	          'div',
	          null,
	          !this.props.noOverlay && _react2['default'].createElement('div', {
	            className: ('bm-overlay ' + this.props.overlayClassName).trim(),
	            onClick: function () {
	              return !_this3.shouldDisableOverlayClick() && _this3.toggleMenu();
	            },
	            style: this.getStyles('overlay')
	          }),
	          _react2['default'].createElement(
	            'div',
	            {
	              id: this.props.id,
	              className: ('bm-menu-wrap ' + this.props.className).trim(),
	              style: this.getStyles('menuWrap')
	            },
	            styles.svg && _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-morph-shape ' + this.props.morphShapeClassName).trim(),
	                style: this.getStyles('morphShape')
	              },
	              _react2['default'].createElement(
	                'svg',
	                {
	                  width: '100%',
	                  height: '100%',
	                  viewBox: '0 0 100 800',
	                  preserveAspectRatio: 'none'
	                },
	                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-menu ' + this.props.menuClassName).trim(),
	                style: this.getStyles('menu')
	              },
	              _react2['default'].createElement(
	                'nav',
	                {
	                  className: ('bm-item-list ' + this.props.itemListClassName).trim(),
	                  style: this.getStyles('itemList')
	                },
	                _react2['default'].Children.map(this.props.children, function (item, index) {
	                  if (item) {
	                    var extraProps = {
	                      key: index,
	                      style: _this3.getStyles('item', index, item.props.style)
	                    };
	                    return _react2['default'].cloneElement(item, extraProps);
	                  }
	                })
	              )
	            ),
	            this.props.customCrossIcon !== false && _react2['default'].createElement(
	              'div',
	              { style: this.getStyles('closeButton') },
	              _react2['default'].createElement(_CrossIcon2['default'], {
	                onClick: function () {
	                  return _this3.toggleMenu();
	                },
	                styles: this.props.styles,
	                customIcon: this.props.customCrossIcon,
	                className: this.props.crossButtonClassName,
	                crossClassName: this.props.crossClassName
	              })
	            )
	          ),
	          this.props.customBurgerIcon !== false && _react2['default'].createElement(
	            'div',
	            { style: this.getStyles('burgerIcon') },
	            _react2['default'].createElement(_BurgerIcon2['default'], {
	              onClick: function () {
	                return _this3.toggleMenu();
	              },
	              styles: this.props.styles,
	              customIcon: this.props.customBurgerIcon,
	              className: this.props.burgerButtonClassName,
	              barClassName: this.props.burgerBarClassName
	            })
	          )
	        );
	      }
	    }]);
	
	    return Menu;
	  })(_react.Component);
	
	  Menu.propTypes = {
	    bodyClassName: _propTypes2['default'].string,
	    burgerBarClassName: _propTypes2['default'].string,
	    burgerButtonClassName: _propTypes2['default'].string,
	    crossButtonClassName: _propTypes2['default'].string,
	    crossClassName: _propTypes2['default'].string,
	    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    disableOverlayClick: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func]),
	    id: _propTypes2['default'].string,
	    isOpen: _propTypes2['default'].bool,
	    itemListClassName: _propTypes2['default'].string,
	    menuClassName: _propTypes2['default'].string,
	    morphShapeClassName: _propTypes2['default'].string,
	    noOverlay: _propTypes2['default'].bool,
	    onStateChange: _propTypes2['default'].func,
	    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    overlayClassName: _propTypes2['default'].string,
	    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    right: _propTypes2['default'].bool,
	    styles: _propTypes2['default'].object,
	    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	  };
	
	  Menu.defaultProps = {
	    bodyClassName: '',
	    burgerBarClassName: '',
	    burgerButtonClassName: '',
	    className: '',
	    crossButtonClassName: '',
	    crossClassName: '',
	    id: '',
	    itemListClassName: '',
	    menuClassName: '',
	    morphShapeClassName: '',
	    noOverlay: false,
	    onStateChange: function onStateChange() {},
	    outerContainerId: '',
	    overlayClassName: '',
	    pageWrapId: '',
	    styles: {},
	    width: 300
	  };
	
	  return Menu;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(611);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(42);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(34);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(41);
	
	var _HelmetConstants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(37));
	var shallowEqual = _interopDefault(__webpack_require__(43));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 380:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"formContainer":"src-components-EmailForm----emailform-module---formContainer---3nYO3","input":"src-components-EmailForm----emailform-module---input---37xMV","button":"src-components-EmailForm----emailform-module---button---2Hs3Q","leftCol":"src-components-EmailForm----emailform-module---leftCol---2wHlk","rightCol":"src-components-EmailForm----emailform-module---rightCol---3sCKY"};

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(23);
	
	var _gatsbyPluginMailchimp = __webpack_require__(452);
	
	var _gatsbyPluginMailchimp2 = _interopRequireDefault(_gatsbyPluginMailchimp);
	
	var _emailformModule = __webpack_require__(380);
	
	var _emailformModule2 = _interopRequireDefault(_emailformModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-underscore-dangle */
	/* eslint-disable no-invalid-this */
	
	
	var EmailCaptureForm = function (_React$Component) {
	  _inherits(EmailCaptureForm, _React$Component);
	
	  function EmailCaptureForm() {
	    _classCallCheck(this, EmailCaptureForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this._handleEmailChange = function (e) {
	      _this.setState({ email: e.target.value });
	    };
	
	    _this._validateEmail = function (email) {
	      // eslint-disable-next-line no-useless-escape
	      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	      return re.test(email);
	    };
	
	    _this._postEmailToMailchimp = function (email, attributes) {
	      (0, _gatsbyPluginMailchimp2.default)(email, attributes).then(function (result) {
	
	        /*
	         * Mailchimp always returns a 200 response
	         * So we check the result for MC errors & failures
	         */
	        if (result.result === "success") {
	          // Email address succesfully subcribed to Mailchimp
	          _this.setState({
	            status: "success",
	            msg: result.msg
	          });
	        } else {
	          _this.setState({
	            status: "error",
	            msg: result.msg
	          });
	        }
	      }).catch(function (err) {
	        // Network failures, timeouts, etc
	        _this.setState({
	          status: "error",
	          msg: err
	        });
	      });
	    };
	
	    _this._handleFormSubmit = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (!_this._validateEmail(_this.state.email)) {
	        _this.setState({
	          status: "error",
	          msg: "Please enter a valid email address."
	        });
	        return false;
	      }
	
	      _this.setState({
	        status: "sending",
	        msg: null
	      },
	      // SetState callback (subscribe email to MC)
	      // eslint-disable-next-line no-underscore-dangle
	      _this._postEmailToMailchimp(_this.state.email, { pathname: document.location.pathname }));
	    };
	
	    _this.state = { email: "" };
	    return _this;
	  }
	
	  // Update state each time user edits their email address
	
	
	  // Post to MC server & handle its response
	
	
	  // eslint-disable-next-line consistent-return
	
	
	  EmailCaptureForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "container", style: { paddingTop: (0, _typography.rhythm)(1.5) } },
	      this.state.status === "success" ? _react2.default.createElement(
	        "div",
	        { style: { paddingBottom: (0, _typography.rhythm)(1.5) } },
	        "Thank you!",
	        _react2.default.createElement("br", null),
	        "You are now subscribed to the newsletter."
	      ) : _react2.default.createElement(
	        "div",
	        { className: _emailformModule2.default.formContainer },
	        _react2.default.createElement(
	          "div",
	          { className: _emailformModule2.default.leftCol },
	          _react2.default.createElement(
	            "h2",
	            { style: { marginBottom: (0, _typography.rhythm)(0.5) } },
	            "Join the mailing list"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Sign up for updates on new training courses and blog posts."
	          )
	        ),
	        _react2.default.createElement(
	          "form",
	          {
	            id: "email-capture",
	            method: "post",
	            noValidate: true,
	            className: _emailformModule2.default.rightCol
	          },
	          _react2.default.createElement("input", {
	            className: _emailformModule2.default.input,
	            type: "email",
	            name: "email",
	            placeholder: "you@email.com",
	            onChange: this._handleEmailChange
	          }),
	          _react2.default.createElement(
	            "button",
	            {
	              className: _emailformModule2.default.button,
	              type: "submit",
	              onClick: this._handleFormSubmit
	            },
	            "Subscribe"
	          ),
	          this.state.status === "error" && _react2.default.createElement("div", {
	            dangerouslySetInnerHTML: { __html: this.state.msg },
	            style: { marginTop: (0, _typography.rhythm)(0.5) }
	          })
	        ),
	        _react2.default.createElement("div", { className: "cl" })
	      )
	    );
	  };
	
	  return EmailCaptureForm;
	}(_react2.default.Component);
	
	exports.default = EmailCaptureForm;
	module.exports = exports["default"];

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMailto = __webpack_require__(78);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	var _index = __webpack_require__(274);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(180);
	
	var _index4 = _interopRequireDefault(_index3);
	
	__webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line one-var
	var FooterLink = function FooterLink(props) {
	  return _react2.default.createElement(
	    "li",
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.to },
	      props.children
	    )
	  );
	};
	
	FooterLink.propTypes = {
	  to: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.string.isRequired
	};
	
	// eslint-disable-next-line one-var
	var Footer = function Footer(_ref) {
	  var siteMetadata = _ref.siteMetadata;
	  return _react2.default.createElement(
	    "footer",
	    null,
	    _react2.default.createElement(_index2.default, null),
	    _react2.default.createElement(
	      "div",
	      { className: "sub" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-50 fr" },
	          _react2.default.createElement(
	            "h6",
	            null,
	            _react2.default.createElement(
	              _reactMailto2.default,
	              { email: siteMetadata.email, obfuscate: false },
	              siteMetadata.email
	            )
	          )
	        ),
	        _react2.default.createElement(_index4.default, { social: siteMetadata.social }),
	        _react2.default.createElement(
	          "div",
	          { className: "col-50" },
	          _react2.default.createElement(
	            "h6",
	            null,
	            "\xA9 ",
	            new Date().getFullYear(),
	            " ",
	            siteMetadata.title,
	            " All rights reserved"
	          )
	        ),
	        _react2.default.createElement("div", { className: "cl" })
	      )
	    )
	  );
	};
	
	Footer.propTypes = {
	  siteMetadata: _propTypes2.default.shape({
	    title: _propTypes2.default.string.isRequired,
	    email: _propTypes2.default.string.isRequired,
	    social: _propTypes2.default.shape({
	      twitter: _propTypes2.default.string.isRequired,
	      linkedin: _propTypes2.default.string.isRequired,
	      github: _propTypes2.default.string.isRequired
	    })
	  })
	};
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 383:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _slide = __webpack_require__(612);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	var _index = __webpack_require__(180);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _typography = __webpack_require__(23);
	
	__webpack_require__(384);
	
	__webpack_require__(383);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListLink = function ListLink(props) {
	  return _react2.default.createElement(
	    "li",
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.to },
	      props.children
	    )
	  );
	};
	
	ListLink.propTypes = {
	  to: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.string.isRequired
	};
	
	// eslint-disable-next-line one-var
	// Const Header = ({ title, hideGuides }) => <header>
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { menuOpen: false };
	    return _this;
	  }
	
	  /*
	   * This keeps your state in sync with the opening/closing of the menu
	   * via the default means, e.g. clicking the X, pressing the ESC key etc.
	   */
	
	
	  Header.prototype.handleStateChange = function handleStateChange(state) {
	    this.setState({ menuOpen: state.isOpen });
	  };
	
	  // This can be used to close the menu, e.g. when a user clicks a menu item
	
	
	  Header.prototype.closeMenu = function closeMenu() {
	    this.setState({ menuOpen: false });
	  };
	
	  /*
	   * This can be used to toggle the menu, e.g. when using a custom icon
	   * Tip: You probably want to hide either/both default icons if using a custom icon
	   * See https://github.com/negomi/react-burger-menu#custom-icons
	   */
	
	
	  Header.prototype.toggleMenu = function toggleMenu() {
	    this.setState({ menuOpen: !this.state.menuOpen });
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        hideGuides = _props.hideGuides,
	        social = _props.social;
	
	
	    return _react2.default.createElement(
	      "header",
	      { className: "header", style: { paddingTop: (0, _typography.rhythm)(2) } },
	      _react2.default.createElement(
	        "span",
	        { className: "mobileNav" },
	        _react2.default.createElement(
	          _slide2.default,
	          {
	            right: true,
	            isOpen: this.state.menuOpen,
	            onStateChange: function onStateChange(state) {
	              return _this2.handleStateChange(state);
	            }
	          },
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { onClick: function onClick() {
	                  return _this2.closeMenu();
	                }, to: "/" },
	              "Blog"
	            )
	          ),
	          hideGuides || _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { onClick: function onClick() {
	                  return _this2.closeMenu();
	                }, to: "/guides" },
	              "Guides"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { onClick: function onClick() {
	                  return _this2.closeMenu();
	                }, to: "/training" },
	              "Training"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { onClick: function onClick() {
	                  return _this2.closeMenu();
	                }, to: "/about" },
	              "About"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "h1",
	          {
	            style: {
	              lineHeight: (0, _typography.rhythm)(2),
	              fontSize: (0, _typography.rhythm)(1.5)
	            }
	          },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            "Andrew Griffiths"
	          )
	        ),
	        _react2.default.createElement(
	          "nav",
	          { className: "desktopNav" },
	          _react2.default.createElement(
	            "ul",
	            { className: "links", style: { lineHeight: (0, _typography.rhythm)(1.5) } },
	            _react2.default.createElement(
	              ListLink,
	              { to: "/" },
	              "Blog"
	            ),
	            hideGuides || _react2.default.createElement(
	              ListLink,
	              { to: "/guides" },
	              "Guides"
	            ),
	            _react2.default.createElement(
	              ListLink,
	              { to: "/about" },
	              "About"
	            ),
	            _react2.default.createElement(
	              ListLink,
	              { to: "/training" },
	              "Training"
	            )
	          ),
	          _react2.default.createElement(_index2.default, { social: social })
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	Header.propTypes = {
	  hideGuides: _propTypes2.default.bool,
	  title: _propTypes2.default.string.isRequired,
	  social: _propTypes2.default.shape({
	    twitter: _propTypes2.default.string.isRequired,
	    linkedin: _propTypes2.default.string.isRequired,
	    github: _propTypes2.default.string.isRequired
	  })
	};
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stripSlash = function stripSlash(str) {
		return str.substring(str.length - 1) === "/" ? str.substring(0, str.length - 1) : str;
	};
	
	var MetaTags = function (_React$Component) {
		_inherits(MetaTags, _React$Component);
	
		function MetaTags() {
			_classCallCheck(this, MetaTags);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		MetaTags.prototype.render = function render() {
			var _props = this.props,
			    pathname = _props.pathname,
			    siteMetadata = _props.siteMetadata,
			    pathnameWithoutSlash = stripSlash(pathname),
			    pathparts = pathnameWithoutSlash.split("/"),
			    currentPage = pathnameWithoutSlash === "" ? "home" : pathparts[1],
			    allMetaTags = siteMetadata.metaTags,
			    metaTags = allMetaTags.filter(function (_ref) {
				var page = _ref.page;
	
				return page === currentPage;
			});
	
	
			return _react2.default.createElement(
				"div",
				null,
				metaTags.length === 1 && _react2.default.createElement(_reactHelmet2.default, {
					title: metaTags[0].page === "home" ? metaTags[0].title : metaTags[0].title + " | " + siteMetadata.title,
					meta: [{
						content: siteMetadata.googleSiteVerification,
						name: "google-site-verification"
					}, {
						content: metaTags[0].description,
						name: "description"
					}, {
						content: metaTags[0].keywords,
						name: "keywords"
					}]
				})
			);
		};
	
		return MetaTags;
	}(_react2.default.Component);
	
	MetaTags.propTypes = {
		pathname: _propTypes2.default.string.isRequired,
		siteMetadata: _propTypes2.default.shape({
			googleSiteVerification: _propTypes2.default.string.isRequired,
			metaTags: _propTypes2.default.array.isRequired,
			title: _propTypes2.default.string.isRequired
		})
	};
	exports.default = MetaTags;
	module.exports = exports["default"];

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _logo_60pxheight = __webpack_require__(176);
	
	var _logo_60pxheight2 = _interopRequireDefault(_logo_60pxheight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// https://developers.google.com/search/docs/data-types/article#logo-guidelines
	
	
	var JsonLD = function (_React$Component) {
	  _inherits(JsonLD, _React$Component);
	
	  function JsonLD() {
	    _classCallCheck(this, JsonLD);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  JsonLD.createStructure = function createStructure(siteMetadata) {
	
	    /*
	     * Article type example taken from:
	     * https://search.google.com/structured-data/testing-tool
	     *
	     * Reference:
	     * http://schema.org/Organization
	     * https://developers.google.com/search/docs/data-types/social-profile
	     * https://www.hallaminternet.com/implementing-json-ld-structured-data/
	     */
	    return {
	      "@type": "Organization",
	      name: siteMetadata.title,
	      url: siteMetadata.siteUrl,
	      logo: {
	        "@type": "ImageObject",
	        height: 60,
	        url: "" + siteMetadata.siteUrl + _logo_60pxheight2.default
	      },
	      sameAs: [siteMetadata.social.twitter, siteMetadata.social.linkedin, siteMetadata.social.github]
	    };
	  };
	
	  JsonLD.prototype.render = function render() {
	    var siteMetadata = this.props.siteMetadata,
	        structuredData = JsonLD.createStructure(siteMetadata);
	
	
	    structuredData["@context"] = "http://schema.org";
	
	    return _react2.default.createElement("script", {
	      type: "application/ld+json",
	      dangerouslySetInnerHTML: { __html: JSON.stringify(structuredData) }
	    });
	  };
	
	  return JsonLD;
	}(_react2.default.Component);
	
	JsonLD.propTypes = {
	  siteMetadata: _propTypes2.default.shape({
	    siteUrl: _propTypes2.default.string.isRequired,
	    social: _propTypes2.default.shape({
	      twitter: _propTypes2.default.string.isRequired,
	      linkedin: _propTypes2.default.string.isRequired,
	      github: _propTypes2.default.string.isRequired
	    }),
	    title: _propTypes2.default.string.isRequired
	  })
	};
	
	exports.default = JsonLD;
	module.exports = exports["default"];

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rssLg = __webpack_require__(720);
	
	var _rssLg2 = _interopRequireDefault(_rssLg);
	
	var _socialLinkedinLg = __webpack_require__(722);
	
	var _socialLinkedinLg2 = _interopRequireDefault(_socialLinkedinLg);
	
	var _socialGithubLg = __webpack_require__(721);
	
	var _socialGithubLg2 = _interopRequireDefault(_socialGithubLg);
	
	var _socialMediumLg = __webpack_require__(723);
	
	var _socialMediumLg2 = _interopRequireDefault(_socialMediumLg);
	
	var _socialTwitterLg = __webpack_require__(724);
	
	var _socialTwitterLg2 = _interopRequireDefault(_socialTwitterLg);
	
	__webpack_require__(386);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extractHandle = function extractHandle(url) {
	  var parts = url.split("/");
	
	  return parts[parts.length - 1];
	},
	    SocialIcons = function SocialIcons(_ref) {
	  var social = _ref.social;
	  return _react2.default.createElement(
	    "ul",
	    { className: "iconic-container" },
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: "/rss.xml" },
	        _react2.default.createElement("img", { "data-type": "rss", src: _rssLg2.default, className: "iconic", alt: "rss" })
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: social.linkedin },
	        _react2.default.createElement("img", {
	          "data-type": "linkedin",
	          src: _socialLinkedinLg2.default,
	          className: "iconic",
	          alt: "linkedin"
	        })
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: social.twitter },
	        _react2.default.createElement("img", {
	          "data-type": "twitter",
	          src: _socialTwitterLg2.default,
	          className: "iconic",
	          alt: "twitter"
	        }),
	        _react2.default.createElement(
	          "span",
	          null,
	          extractHandle(social.twitter)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: social.github },
	        _react2.default.createElement("img", {
	          "data-type": "github",
	          src: _socialGithubLg2.default,
	          className: "iconic",
	          alt: "github"
	        }),
	        _react2.default.createElement(
	          "span",
	          null,
	          extractHandle(social.github)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        "a",
	        { href: social.medium },
	        _react2.default.createElement("img", {
	          "data-type": "medium",
	          src: _socialMediumLg2.default,
	          className: "iconic",
	          alt: "medium"
	        }),
	        _react2.default.createElement(
	          "span",
	          null,
	          extractHandle(social.medium)
	        )
	      )
	    )
	  );
	};
	
	SocialIcons.propTypes = {
	  social: _propTypes2.default.shape({
	    twitter: _propTypes2.default.string.isRequired,
	    linkedin: _propTypes2.default.string.isRequired,
	    medium: _propTypes2.default.string,
	    github: _propTypes2.default.string.isRequired
	  })
	};
	exports.default = SocialIcons;
	module.exports = exports["default"];

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEyOCIgaGVpZ2h0PSIxMjgiIGRhdGEtaWNvbj0icnNzIiBmaWxsPSIjZmZmIiBjbGFzcz0iaWNvbmljIGljb25pYy1yc3MgaWNvbmljLXNpemUtbGciIHZpZXdCb3g9IjAgMCAxMjggMTI4Ij4KICA8ZyBjbGFzcz0iaWNvbmljLW1ldGFkYXRhIj4KICAgIDx0aXRsZT5Sc3M8L3RpdGxlPgogIDwvZz4KICA8ZyBjbGFzcz0iaWNvbmljLWNvbnRhaW5lciIgZGF0YS13aWR0aD0iMTA4IiBkYXRhLWhlaWdodD0iMTA4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMCAxMCkiPgogICAgPHBhdGggZD0iTTI0IDk2YzAgNi42MzMtNS4zNzIgMTItMTIuMDAzIDEyLTYuNjI1IDAtMTEuOTk3LTUuMzY3LTExLjk5Ny0xMiAwLTYuNjMyIDUuMzcyLTEyIDExLjk5Ny0xMiA2LjYzMSAwIDEyLjAwMyA1LjM2OCAxMi4wMDMgMTJ6IiBjbGFzcz0iaWNvbmljLXJzcy1jZW50ZXIgaWNvbmljLXByb3BlcnR5LWFjY2VudCBpY29uaWMtcHJvcGVydHktZmlsbCIgLz4KICAgIDxwYXRoIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSI4IiBkPSJNMTIgNjBjMTkuODgyIDAgMzYgMTYuMTE4IDM2IDM2IiBjbGFzcz0iaWNvbmljLXJzcy13YXZlIGljb25pYy1yc3Mtd2F2ZS1pbm5lciBpY29uaWMtcHJvcGVydHktc3Ryb2tlIiBmaWxsPSJub25lIiAvPgogICAgPHBhdGggc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjgiIGQ9Ik0xMiAzMmMzNS4zNDYgMCA2NCAyOC42NTQgNjQgNjQiIGNsYXNzPSJpY29uaWMtcnNzLXdhdmUgaWNvbmljLXJzcy13YXZlLW1pZGRsZSBpY29uaWMtcHJvcGVydHktc3Ryb2tlIiBmaWxsPSJub25lIiAvPgogICAgPHBhdGggc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjgiIGQ9Ik0xMiA0YzUwLjgxIDAgOTIgNDEuMTkgOTIgOTIiIGNsYXNzPSJpY29uaWMtcnNzLXdhdmUgaWNvbmljLXJzcy13YXZlLW91dGVyIGljb25pYy1wcm9wZXJ0eS1zdHJva2UiIGZpbGw9Im5vbmUiIC8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 723:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS1pY29uPSJzb2NpYWwtbWVkaXVtIiB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiBjbGFzcz0iaWNvbmljIGljb25pYy1zb2NpYWwgaWNvbmljLXNpemUtbGcgaWNvbmljLXNvY2lhbC1tZWRpdW0iIHZpZXdCb3g9IjAgMCA0NSA0NSI+CiAgPGc+CiAgICA8dGl0bGU+U29jaWFsIE1lZGl1bTwvdGl0bGU+CiAgPC9nPgoKPHBhdGggZD0iTTUgNDBWNWgzNXYzNUg1em04LjU2LTEyLjYyN2MwIC41NTUtLjAyNy42ODctLjMxOCAxLjAzbC0yLjQ1NyAyLjk4NXYuMzk2aDYuOTc0di0uMzk2bC0yLjQ1Ni0yLjk4NWMtLjI5MS0uMzQzLS4zNDQtLjUwMi0uMzQ0LTEuMDNWMTguNDJsNi4xMjcgMTMuMzY0aC43MTRsNS4yNTYtMTMuMzY0djEwLjY0NGMwIC4yOSAwIC4zNDItLjE4NS41MjhsLTEuODQ4IDEuNzk2di4zOTZoOS4xOXYtLjM5NmwtMS44MjItMS43OTZjLS4xODQtLjE4Ni0uMjEtLjIzOC0uMjEtLjUyOFYxNS45MzdjMC0uMjkxLjAyNi0uMzQ0LjIxLS41MjhsMS44MjMtMS43OTd2LS4zOTZoLTYuNDcxbC00LjYyMiAxMS41NDItNS4yMDMtMTEuNTQyaC02Ljc5di4zOTZsMi4xNCAyLjY0Yy4yMzkuMjkyLjI5MS4zNy4yOTEuNzY4djEwLjM1M3oiPjwvcGF0aD4KCjwhLS0gPHN2ZyBjbGFzcz0ic3ZnSWNvbi11c2UiIHdpZHRoPSI0NSIgaGVpZ2h0PSI0NSIgdmlld0JveD0iMCAwIDQ1IDQ1Ij48cGF0aCBkPSJNNSA0MFY1aDM1djM1SDV6bTguNTYtMTIuNjI3YzAgLjU1NS0uMDI3LjY4Ny0uMzE4IDEuMDNsLTIuNDU3IDIuOTg1di4zOTZoNi45NzR2LS4zOTZsLTIuNDU2LTIuOTg1Yy0uMjkxLS4zNDMtLjM0NC0uNTAyLS4zNDQtMS4wM1YxOC40Mmw2LjEyNyAxMy4zNjRoLjcxNGw1LjI1Ni0xMy4zNjR2MTAuNjQ0YzAgLjI5IDAgLjM0Mi0uMTg1LjUyOGwtMS44NDggMS43OTZ2LjM5Nmg5LjE5di0uMzk2bC0xLjgyMi0xLjc5NmMtLjE4NC0uMTg2LS4yMS0uMjM4LS4yMS0uNTI4VjE1LjkzN2MwLS4yOTEuMDI2LS4zNDQuMjEtLjUyOGwxLjgyMy0xLjc5N3YtLjM5NmgtNi40NzFsLTQuNjIyIDExLjU0Mi01LjIwMy0xMS41NDJoLTYuNzl2LjM5NmwyLjE0IDIuNjRjLjIzOS4yOTIuMjkxLjM3LjI5MS43Njh2MTAuMzUzeiI+PC9wYXRoPjwvc3ZnPiAtLT4KCjwvc3ZnPgo="

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgZGF0YS1pY29uPSJzb2NpYWwtdHdpdHRlciIgd2lkdGg9IjEyOCIgaGVpZ2h0PSIxMjgiIGZpbGw9IiNmZmYiIHN0cm9rZT0iI2ZmZiIgZGF0YS1jb250YWluZXItdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMiApIHNjYWxlKDEgMSApIiB2aWV3Qm94PSIwIDAgMTI4IDEyOCI+CiAgPHBhdGggZD0iTTg4LjYyNSAwYy0xNC41MDQgMC0yNi4yODEgMTEuNzUxLTI2LjI4MSAyNi4yNSAwIDIuMDU4LjIzOSA0LjA3OS42ODggNi0yMS44MjYtMS4wOTUtNDEuMTczLTExLjU1My01NC4xMjUtMjcuNDM4LTIuMjYgMy44NzctMy41NjMgOC4zNzctMy41NjMgMTMuMTg4IDAgOS4xMDkgNC42NDIgMTcuMTM2IDExLjY4OCAyMS44NDQtNC4zMDUtLjEzNy04LjMzNC0xLjMxNS0xMS44NzUtMy4yODEtLjAwMi4xMDkgMCAuMjMzIDAgLjM0NCAwIDEyLjcyMSA5LjA0OSAyMy4zMzggMjEuMDYzIDI1Ljc1LTIuMjA0LjYtNC41NDMuOTA2LTYuOTM4LjkwNi0xLjY5MiAwLTMuMzM1LS4xNjItNC45MzgtLjQ2OSAzLjM0MSAxMC40MzEgMTMuMDQgMTguMDM4IDI0LjUzMSAxOC4yNS04Ljk4NyA3LjA0Mi0yMC4zMjIgMTEuMjE5LTMyLjYyNSAxMS4yMTktMi4xMTkgMC00LjE5Ni0uMTAyLTYuMjUtLjM0NCAxMS42MjEgNy40NSAyNS40MiAxMS43ODEgNDAuMjUgMTEuNzgxIDQ4LjMwMyAwIDc0LjcxOS0zOS45OTMgNzQuNzE5LTc0LjY4OCAwLTEuMTM5LS4wMTEtMi4yOC0uMDYzLTMuNDA2IDUuMTMxLTMuNzAyIDkuNTczLTguMzI5IDEzLjA5NC0xMy41OTQtNC43MSAyLjA4OC05Ljc4MiAzLjQ5LTE1LjA5NCA0LjEyNSA1LjQyMi0zLjI0OSA5LjYwMi04LjQgMTEuNTYzLTE0LjUzMS01LjA3NCAzLjAwOC0xMC43MDYgNS4xOTctMTYuNjg4IDYuMzc1LTQuNzktNS4xMDItMTEuNjAzLTguMjgxLTE5LjE1Ni04LjI4MXoiCiAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMikiIC8+Cjwvc3ZnPgo="

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo_60pxheight.95a8c598.jpeg";

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(276);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _metaTags = __webpack_require__(277);
	
	var _metaTags2 = _interopRequireDefault(_metaTags);
	
	var _Footer = __webpack_require__(275);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _organisation = __webpack_require__(111);
	
	var _organisation2 = _interopRequireDefault(_organisation);
	
	__webpack_require__(391);
	
	__webpack_require__(388);
	
	__webpack_require__(389);
	
	__webpack_require__(390);
	
	var _typography = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TemplateWrapper = function (_React$Component) {
		_inherits(TemplateWrapper, _React$Component);
	
		function TemplateWrapper() {
			_classCallCheck(this, TemplateWrapper);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		TemplateWrapper.prototype.render = function render() {
			var _props = this.props,
			    location = _props.location,
			    children = _props.children,
			    data = _props.data,
			    siteMetadata = data.site.siteMetadata,
			    paddingTop = (0, _typography.rhythm)(2);
	
	
			return _react2.default.createElement(
				"div",
				{ className: "container-outer" },
				_react2.default.createElement(_metaTags2.default, { pathname: location.pathname, siteMetadata: siteMetadata }),
				_react2.default.createElement(_Header2.default, {
					title: siteMetadata.title,
					hideGuides: siteMetadata.hideGuides,
					social: siteMetadata.social
				}),
				_react2.default.createElement(_organisation2.default, { siteMetadata: siteMetadata }),
				_react2.default.createElement(
					"div",
					{ className: "container-layout", style: { paddingTop: paddingTop } },
					children()
				),
				_react2.default.createElement(_Footer2.default, { siteMetadata: siteMetadata })
			);
		};
	
		return TemplateWrapper;
	}(_react2.default.Component);
	
	TemplateWrapper.propTypes = {
		children: _propTypes2.default.func,
		location: _propTypes2.default.shape({ pathname: _propTypes2.default.string.isRequired }),
		data: _propTypes2.default.shape({
			site: _propTypes2.default.shape({
				siteMetadata: _propTypes2.default.shape({
					email: _propTypes2.default.string.isRequired,
					googleSiteVerification: _propTypes2.default.string.isRequired,
					hideGuides: _propTypes2.default.bool,
					metaTags: _propTypes2.default.array.isRequired,
					siteUrl: _propTypes2.default.string.isRequired,
					social: _propTypes2.default.shape({
						twitter: _propTypes2.default.string.isRequired,
						medium: _propTypes2.default.string,
						linkedin: _propTypes2.default.string.isRequired,
						github: _propTypes2.default.string.isRequired
					}),
					title: _propTypes2.default.string.isRequired
				})
			})
		})
	};
	
	exports.default = TemplateWrapper;
	// eslint-disable-next-line one-var
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-94c9f458fbba928b5e61.js